function resetAssetNameIfDefault (element) {

	const v = element.value || element.textContent;

	if (/_/.test(v)) {

		if (element.tagName === 'INPUT') {

			element.value = '';

		} else {

			element.textContent = '';

		}

	}

}

export default resetAssetNameIfDefault;
